import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AppVersionService } from 'src/app/core/services/version/appversionservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  @Input() customFooter: string = '';
  version: string = '';
  currentYear: number = new Date().getFullYear();

  constructor(private versionService: AppVersionService) { }

  ngOnInit(): void {
    this.versionService.getVersion().then((version) => {
      this.version = version;
    });
    console.log(environment.lastVersion);
  }

}
